<template>
  <div class="portfolio-wrapper">
    <div class="portfolio">
      <div class="portfolio-header">
        <div class="portfolio-title">
          Tus inversiones
        </div>
      </div>
      <!-- <div class="wallet">
        <div class="wallet-balance">
          <div class="wallet-title">Balance en cuenta</div>
          <div class="wallet-value">$12,307.68</div>
        </div>
        <div class="wallet-button">Retirar</div>
      </div> -->
      <div class="portfolio-stats">
        <div class="stat-card background-1">
          <div class="stat-name">Inversión total</div>
          <div class="stat-description">El total que has invertido en proyectos en Flagship.</div>
          <div class="stat-value">{{ formatMoney(totalInvestment) }}</div>
        </div>
        <div class="stat-card background-2">
          <div class="stat-name">Total recibido</div>
          <div class="stat-description">El total que has recibido de las ventas de los proyectos.</div>
          <div class="stat-value">{{ formatMoney(totalReturn) }}</div>
        </div>
        <div class="stat-card background-3">
          <div class="stat-name">Retorno actual</div>
          <div class="stat-description">Porcentaje de ganancia respecto a tus inversiones.</div>
          <div class="stat-value" v-if="totalInvestment">{{ (totalReturn/totalInvestment*100).toFixed(2) }}%</div>
          <div class="stat-value" v-else>0%</div>
        </div>
      </div>
      <div class="projects">
        <PortfolioCard v-for="(investment) in investments" :key="investment.id" :investment="investment" />
      </div>
      <div class="empty-state" v-if="investments.length === 0">
        ¡No eres socio de ningún restaurante aún!
        <a class="button" href="/#projects">Ver proyectos</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Chart from 'chart.js';
import moment from 'moment';
import formatMixin from '@/mixins/formatMixin';
import PortfolioCard from '@/components/PortfolioCard.vue';

export default {
  data() {
    return {
      investments: [],
      selectedId: null,
      currentIndex: null,
      moment,
    };
  },
  components: {
    PortfolioCard,
  },
  mixins: [formatMixin],
  watch: {
    currentIndex() {
      if (this.currentIndex !== null) {
        const project = this.investments[this.currentIndex];

        const ctx = document.getElementById(`myChart-${this.currentIndex}`).getContext('2d');
        const fixedPayments = [];
        const labels = [];

        for (let i = 0; i < project.payments.length; i += 1) {
          const element = project.payments[i];
          fixedPayments.push(element.payment);
          labels.push(this.moment(project.project.paymentsStartDate).add(i, 'M').format('MMM YYYY'));
        }

        // eslint-disable-next-line
        const myChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels,
            datasets: [{
              label: 'Dataset 1',
              backgroundColor: '#2c70c1',
              borderColor: '#2c70c1',
              borderWidth: 1,
              data: fixedPayments,
            }],
          },
          options: {
            legend: {
              display: false,
            },
            title: {
              display: true,
              text: 'Retornos',
            },
          },
        });
      }
    },
  },
  computed: {
    totalInvestment() {
      if (this.investments) {
        let sum = 0;
        for (let i = 0; i < this.investments.length; i += 1) {
          const element = this.investments[i];
          sum += parseInt(element.investment, 10);
        }
        return sum;
      }
      return 0;
    },
    totalReturn() {
      let total = 0;
      for (let i = 0; i < this.investments.length; i += 1) {
        const element = this.investments[i];
        const payments = this.totalPayments(element.payments);
        total += payments;
      }
      return total;
    },
  },
  methods: {
    totalPayments(payments) {
      let total = 0;
      for (let i = 0; i < payments.length; i += 1) {
        const element = payments[i];
        total += parseInt(element.payment, 10);
      }
      return total;
    },
    stylizeNumber(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
  mounted() {
    axios.get(`${process.env.VUE_APP_SERVER_URL}/user/investments`)
      .then((reponse) => {
        this.investments = reponse.data;
      });
  },
};
</script>

<style lang="scss" scoped>
.portfolio-wrapper {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  background-color: #fafafa;
  font-family: 'Inter', sans-serif;
}
.portfolio {
  width: 900px;
  padding: 90px 20px;
  display: flex;
  flex-direction: column;
}
.portfolio-header {
  width: 100%;
  display: flex;
  padding: 15px 0;
}
.portfolio-title {
  width: 50%;
  margin: 0 0 16px 0;
  color: #202124;
  font-size: 28px;
  font-weight: bold;
}
.projects {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 30px;
}
.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-weight: bolder;
  font-size: 24px;
}
.button {
  background-color: #2c70c1;
  margin-top: 50px;
  color: white;
  padding: 14px 0;
  width: 200px;
  display: flex;
  justify-content: center;
  font-weight: bold;
  font-size: 15px;
  cursor: pointer;
  border-radius: 4px;
}
.portfolio-stats {
  display: flex;
  justify-content: space-between;
}
.stat-card {
  width: 32%;
  color: white;
  border-radius: 8px;
  padding: 20px;
}
.stat-name {
  font-size: 16px;
  margin-bottom: 6px;
  color: black;
  font-weight: 500;
}
.stat-description {
  color: rgb(65, 65, 65);
  margin-bottom: 14px;
  line-height: 18px;
}
.stat-value {
  font-size: 32px;
}
.background-1 {
  background: #fae8e7;
  color: #ef5841;
}
.background-2 {
  background: #e5ebfb;
  color: #3479e9;
}
.background-3 {
  background: #e6f5ee;
  color: #3fc67d;
}
.wallet {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e8e8e8;
  background-color: white;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 26px;
}
.wallet-title {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 12px;
}
.wallet-value {
  font-size: 30px;
}
.wallet-button {
  background-color: #3479e9;
  color: white;
  padding: 12px 36px;
  display: flex;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
}

@media only screen and (max-width: 1100px) {
  .portfolio {
    width: 99%;
  }
}
@media only screen and (max-width: 650px) {
  .portfolio {
    width: 99%;
  }
  .portfolio-stats {
    flex-direction: column;
  }
  .stat-card {
    width: 100%;

    & + .stat-card {
      margin-top: 14px;
    }
  }
}
</style>
